






















import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import TextSanitized from "@/common/components/atoms/TextSanitized.vue";
import TheK01Header from "@/general/components/pages/parts/K1Notification/TheK01Header.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import {
  getk1NotificationDetails,
  markK1NotificationAsRead
} from "@/general/store/api";
import commons from "@/common/store/modules/commons";
import {
  InformationMessage,
  InformationMessageTrackerRequest
} from "gen/ricapi/api";
import globals from "@/general/store/modules/globals";

import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheHeader,
    TheFooter,
    TheBreadcrumb,
    TextSanitized,
    TheK01Header
  }
})
export default class K1Notification extends Vue {
  notification: InformationMessage = {
    title: "",
    updated_at: "",
    created_at: "",
    author_name: "",
    author: 0,
    pk: 0,
    message: "",
    has_read: false,
    page_details: {
      previous: {
        title: "",
        url: ""
      },
      next: {
        title: "",
        url: ""
      }
    },
    start_showing: ""
  };

  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "お知らせ一覧",
      url: "",
      pageType: "lower"
    }
  ];

  $refs!: {
    theHeader: TheHeader;
  };

  get title() {
    return this.notification.title;
  }

  get publishedAt() {
    return this.notification.created_at;
  }

  get updatedAt() {
    return this.notification.updated_at;
  }

  get authorName() {
    return this.notification.author_name;
  }

  get authorId() {
    return this.notification.author;
  }

  get content() {
    return this.notification.message;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }
  mounted() {
    AuthStorage.checkLogin();
  }
  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    await commons.setbreadcrumb(this.breadcrumb);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get("id")
      ? parseInt(urlParams.get("id") as string)
      : 1;

    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );

    this.notification = await getk1NotificationDetails(id);

    const informationMessageTrackerRequest: InformationMessageTrackerRequest = {
      user: userDetails.id,
      message: id,
      has_read: true
    };
    await markK1NotificationAsRead(informationMessageTrackerRequest);
  }
}
